module.exports = __webpack_public_path__ + "static/media/logo.ca229513.svg";